import React, { useState } from 'react'

import { RadioButton, Typography } from '@telavita-core/react-design-kit'
import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import { ReactComponent as CheckIcon } from 'static/svg/check.svg'
import { ReactComponent as CircleIcon } from 'static/svg/circle.svg'

import * as S from './styles'

interface RescheduleReservationQuestionModalProps {
  onClose: () => void
  onSelectRescheduleTotalReservation: () => void
  onSelectReschedulePerDateReservation: () => void
}

enum SelectedOption {
  PER_DATE = 'PER_DATE',
  TOTAL = 'TOTAL'
}

export const RescheduleReservationQuestionModal = ({ 
  onClose,
  onSelectReschedulePerDateReservation,
  onSelectRescheduleTotalReservation
}: RescheduleReservationQuestionModalProps): JSX.Element => {
  const [selectedOption, setSelectedOption] = useState<SelectedOption | null>(null)

  const isPerDateOptionSelected = selectedOption === SelectedOption.PER_DATE
  const isTotalOptionSelected = selectedOption === SelectedOption.TOTAL

  const onSubmit = () => {
    if (isPerDateOptionSelected) {
      onSelectReschedulePerDateReservation()
    } else {
      onSelectRescheduleTotalReservation()
    }
    onClose()
  }

  return (
    <ModalGeneric
      modalTitle='Essa reserva é recorrente. O que você deseja remarcar?'
      btnText='PRÓXIMO'
      btnDisabled={!selectedOption}
      onCloseModal={onClose}
      btnOnClick={onSubmit}
      hasButton
    >
      <S.Container>
        <Typography variant='content2'>
          Selecione:
        </Typography>

        <RadioButton 
          isSelected={isPerDateOptionSelected} 
          onSelect={() => setSelectedOption(oldState => oldState === SelectedOption.PER_DATE ? null : SelectedOption.PER_DATE)}
        >
          <S.RadioContentWrapper>
            <S.RadioButtonTextWrapper>
              <Typography variant='content2' weight='bold'>Remarcar um dia específico</Typography>
              <Typography variant='content3'>Remarca apenas os dias escolhidos, mantendo os demais no dia e horário de recorrência.</Typography>
            </S.RadioButtonTextWrapper>
            {isPerDateOptionSelected ? <CheckIcon /> : <CircleIcon />}
          </S.RadioContentWrapper>
        </RadioButton>


        {/* 
          Nesse momento iremos seguir com a opção de remarcar toda a reserva desabilitada.
          Portanto foi colocado temporariamente um componente apenas como placeholder para manter o layout.
          Após o projeto ir para produção, e o fluxo ser corrigido, iremos habilitar a opção de remarcar toda a reserva.

          TODO: Após resolução do fluxo de remarcação total de reserva pelo backend, remover o componente PlaceholderRadioButton
            e descomentar o componente RadioButton abaixo.
        */}

        <S.PlaceholderRadioButton>
          <S.RadioContentWrapper style={{ height: 44 }}>
            <S.RadioButtonTextWrapper >
              <Typography 
                customClassName='placeholderText' 
                variant='content2' 
                weight='bold'
              >
                Remarcar toda a reserva <span>(Em breve)</span>
              </Typography>
            </S.RadioButtonTextWrapper>
          </S.RadioContentWrapper>
        </S.PlaceholderRadioButton>

        {/* <RadioButton
          isSelected={isTotalOptionSelected} 
          onSelect={() => setSelectedOption(oldState => oldState === SelectedOption.TOTAL ? null : SelectedOption.TOTAL)}
        >
          <S.RadioContentWrapper style={{ height: 44 }}>
            <S.RadioButtonTextWrapper >
              <Typography variant='content2' weight='bold'>Remarcar toda a reserva</Typography>
            </S.RadioButtonTextWrapper>
            {isTotalOptionSelected ? <CheckIcon /> : <CircleIcon />}
          </S.RadioContentWrapper>
        </RadioButton> */}

      </S.Container>
    </ModalGeneric>
  )
}